export { getNormalizedPercentageFromValue, getNormalizedValueFromPercentage, getPercentageFromValue, getValueFromPercentage, percentageToCSSValue } from './percentageUtils/index.js';
export { TimeCounter } from './TimeCounter/TimeCounter.js';
export { buildURL, combineURLs, getParamValueFromUrl, isAbsoluteURL } from './urlUtils/index.js';
export { base64DecodeUnicode, base64UrlDecode, isTokenExpired, jwtDecode } from './jwt.js';
export { FORGEROCK_ACCOUNT_TYPES, ForgerockAccountType, MSOProvider, MSO_PROVIDERS_TYPES, USER_TYPES, UserType, getMSOProviderFormatted, getUserTypeByBusinessUnit } from './user.js';
import 'query-string';

function isMobile() {
  return {
    Android() {
      return !!navigator.userAgent.toLowerCase().includes("android");
    },
    iOS() {
      return !!(navigator.userAgent.toLowerCase().includes("iphone") || navigator.userAgent.toLowerCase().includes("ipad") || navigator.userAgent.toLowerCase().includes("ipod"));
    },
    any() {
      return this.Android() || this.iOS();
    }
  };
}
function getInitials(sentence) {
  if (!sentence)
    return [];
  const words = sentence.replace(/,/g, "").split(/\s/);
  return words.filter(Boolean).map((word) => word[0]).filter((initial) => initial !== "");
}
function throttleUntilResolve(fn) {
  let currentOperationPromise;
  return (...args) => {
    if (currentOperationPromise)
      return currentOperationPromise;
    currentOperationPromise = fn(...args);
    return currentOperationPromise.finally(() => {
      currentOperationPromise = void 0;
    });
  };
}
function cacheFunction(fn) {
  let result;
  return (...args) => {
    if (result)
      return result;
    result = fn(...args);
    return result;
  };
}
function createDeferred(data) {
  const deferred = { data };
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}
function isNullish(value) {
  return value === void 0 || value === null;
}

export { cacheFunction, createDeferred, getInitials, isMobile, isNullish, throttleUntilResolve };
//# sourceMappingURL=index.js.map
